export default __webpack_public_path__ + "static/media/Frame 17.3ef5948b.svg";